import styled from 'styled-components/native'
import { getColourScheme, ColourScheme } from 'APP/Helpers/AppearanceUtils'

export const ShadowView = styled.View<{ isSelected?: boolean }>`
  padding: 0px;
  margin: 0px;
  border-radius: ${({ theme }) => theme.metrics.baseMargin / 2}px;
  border: ${({ theme, isSelected }) =>
    getColourScheme() === ColourScheme.DARK
      ? isSelected
        ? `1px solid ${theme.colors.elementsBorder}`
        : 'transparent'
      : 'none'};
  ${({ theme }) => theme.shadows.border};
`
